import { emptyObject } from '@constants/empty';
import { CARD_TYPES } from '@constants/unacademyIcons/anyfeed.constants';
import ContinueWatching from '@unicons-comp/ContinueWatching/ContinueWatching';
import React from 'react';
import { AnyfeedDataProps } from 'types/unacademyIcons/anyfeed.type';

const AnyfeedLesson: React.FC<AnyfeedDataProps> = ({ data, list }) => {
  const { cardType } = data || emptyObject;

  if (cardType === CARD_TYPES.HORIZONTAL_LIST) {
    return <ContinueWatching continueItems={list} />;
  }
};

AnyfeedLesson.displayName = 'AnyfeedLesson';

export default AnyfeedLesson;
